import React from 'react'
import { useTranslation } from 'react-i18next';

import Select from '../inputs/Select'
import { SET_PLACEMENT_SELECTED } from './actions'
import usePlacement from './usePlacement'
import useStyles from './styles'


const SelectPlacement = ({ state, dispatch }) => {
  const { t } = useTranslation(['translation'])
  const classes = useStyles()

  const setPlacement = (_, value) => {
    dispatch({ type: SET_PLACEMENT_SELECTED, data: value })
  }

  return (
    <div className={classes.container}>
      <div className={classes.element}>
        <Select
          id='placement'
          setFieldValue={setPlacement}
          setFieldTouched={() => {}}
          value={state.placementSelected}
          title={t('COMMON.PLACEMENT_SELECTOR_TITLE')}
          options={state.placements}
        />
      </div>
    </div>
  )
}

export { usePlacement }

export default SelectPlacement
